<ng-container *transloco="let t; read: 'partials.exercise_settings'">

  <h3>{{ t('timing') }}</h3>

  <p-table [value]="[{}]" styleClass="p-datatable-sm p-mb-4">

    <ng-template pTemplate="header">
      <tr>
        <th></th>
        <ng-container *ngFor="let slot of slots">
          <th class="p-text-center" [attr.style]="'width: ' + (50 / columns.length) + '%'">{{ slot.name }}</th>
          <th class="p-text-center" *ngIf="slot.rating_start === RatingstartType.End" [attr.style]="'width: ' + (50 / columns.length) + '%'">{{ t('rating') }}</th>
        </ng-container>
      </tr>
    </ng-template>

    <ng-template pTemplate="body">
      <tr>
        <td>{{ t('duration') }}</td>
        <ng-container *ngFor="let slot of slots">
          <td class="p-text-center">
            <input type="text" [ngModel]="status[slot.id].duration" (ngModelChange)="setDuration(slot, $event)" pInputText [ngModelOptions]="{standalone: true}" style="width: 50px" />
          </td>
          <td *ngIf="slot.rating_start === RatingstartType.End" class="p-text-center">
            <input type="text" [ngModel]="status[slot.id].rating_duration" (ngModelChange)="setRatingDuration(slot, $event)" pInputText [ngModelOptions]="{standalone: true}" style="width: 50px" />
          </td>
        </ng-container>
      </tr>
    </ng-template>

  </p-table>

  <h3>{{ t('permissions') }}</h3>

  <p-table [value]="elements" styleClass="p-datatable-sm p-mb-4">

    <ng-template pTemplate="header">
      <tr>
        <th></th>
        <ng-container *ngFor="let slot of slots">
          <th class="p-text-center" [attr.style]="'width: ' + (50 / columns.length) + '%'">{{ slot.name }}</th>
          <th class="p-text-center" *ngIf="slot.rating_start === RatingstartType.End" [attr.style]="'width: ' + (50 / columns.length) + '%'"></th>
        </ng-container>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-element>
      <tr>
        <td>{{ element.name }}</td>
        <ng-container *ngFor="let slot of slots">
          <td class="p-text-center">
            <span class="icon">
              <fa-icon
                *ngIf="isAvailable(slot, element, 'candidate')"
                (click)="togglePermission(slot, element, 'candidate')"
                [class.forbidden]="isForbidden(slot, element, 'candidate')"
                [icon]="faStreetView"
                [attr.aria-label]="element.title + ' ' + t('for_candidate') + ' ' + ((isForbidden('candidate', index)) ? t('show'): t('hide'))"
                pTooltip="{{ t('for_candidate') }}"
                role="link"
              ></fa-icon>
            </span>
            <span class="icon">
              <fa-icon
                *ngIf="isAvailable(slot, element, 'observer')"
                (click)="togglePermission(slot, element, 'observer')"
                [class.forbidden]="isForbidden(slot, element, 'observer')"
                [icon]="faUsers"
                [attr.aria-label]="element.title +  ' ' + t('for_observer') + ' ' + ((isForbidden('observer', index)) ? t('show') : t('hide'))"
                pTooltip="{{ t('for_observer') }}"
                role="link"
              ></fa-icon>
            </span>
            <span class="icon">
              <fa-icon
                *ngIf="isAvailable(slot, element, 'moderator')"
                (click)="togglePermission(slot, element, 'moderator')"
                [class.forbidden]="isForbidden(slot, element, 'moderator')"
                [icon]="faBullhorn"
                [attr.aria-label]="element.title +  ' ' + t('for_moderator') + ' ' + ((isForbidden('moderator', index)) ? t('show') : t('hide'))"
                pTooltip="{{ t('for_moderator') }}"
                role="link"
              ></fa-icon>
            </span>
          </td>
          <td *ngIf="slot.rating_start === RatingstartType.End"></td>
        </ng-container>
      </tr>
    </ng-template>

  </p-table>


</ng-container>
